// extracted by mini-css-extract-plugin
module.exports = {"solar-calculator":"NewVersion_solar-calculator__YKxrm"};